import React from 'react';

const WhyJoinNow: React.FC = () => {
  const features = [
    {
      icon: (
        <svg className="w-12 h-12 text-dance-navy" fill="currentColor" viewBox="0 0 24 24">
          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      ),
      title: "A Home for Dancers",
      description: "Find your people. Whether you're a social dancer, competitor, or just curious, The Dance Floor is where Austin's dance community connects, collaborates, and comes alive."
    },
    {
      icon: (
        <svg className="w-12 h-12 text-dance-navy" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
        </svg>
      ),
      title: "Exclusive Member Events & Gatherings",
      description: "Enjoy early access to members-only mixers, theme nights, and community socials curated to bring dancers together from all styles and studios across the city."
    },
    {
      icon: (
        <svg className="w-12 h-12 text-dance-navy" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
        </svg>
      ),
      title: "Your Source for Austin's Dance Scene",
      description: "Stay in the loop. Members get first access to citywide dance happenings, workshops, and events."
    },
    {
      icon: (
        <svg className="w-12 h-12 text-dance-navy" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ),
      title: "Shape the Future of the Community",
      description: "As a founding member, your feedback and ideas help shape how this space grows, from events to amenities to how we support local artists and instructors."
    }
  ];

  return (
    <section className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-dance-navy mb-6 tracking-wide">
            WHY JOIN NOW?
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-dance-gold to-dance-terracotta mx-auto mb-8"></div>
          <p className="text-xl text-dance-navy/70 max-w-3xl mx-auto leading-relaxed">
            Be part of Austin's most vibrant dance community from day one
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-dance-navy/10 group hover:-translate-y-2">
              <div className="text-center">
                <div className="flex justify-center mb-6">
                  <div className="p-4 bg-gradient-to-br from-dance-gold/20 to-dance-terracotta/20 rounded-xl group-hover:scale-110 transition-transform duration-300">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-dance-navy mb-4 tracking-wide">
                  {feature.title}
                </h3>
                <p className="text-dance-navy/80 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyJoinNow;
